<div [hidden]="loading" id="paypal-button-container" class="single-column-row" style="position: relative"> <!-- [hidden]="loading"-->
    @if (!totalAmountToPay) {
        <div style="height:100%; width:100%; position:absolute; z-index:1000000000; opacity:60%; background-color:white;"></div>
    }
    @if (showNewWindowOverlay) {
        <div (click)="PayInNewTab()" style="height:100%; width:100%; position:absolute; z-index:100000000; opacity:0%; cursor:pointer;"></div>
    }

    <!-- PayPal Commerce Platform will create buttons here -->
</div>

<!-- for ppcp express we dont have a postal code box to input commands  -->
@if (!Scope.paymentProcessor!.StoredPaymentMethodsSupported && isDebug) {
    <lib-button
        (clicked)="ToggleDebugNewTab()">
        <ng-container label>
            @if (debugNewTab) {
                DEBUG: opening in new tab
            } @else {
                DEBUG: opening in current tab
            }
        </ng-container>
    </lib-button>
}

<!-- Hidden input to match style between PayPal fields and our own -->
<div [hidden]="true" class="v3"><input #payPalInputStyleElement class="paypal-fontmatch"></div>

@if (Scope.paymentProcessor!.StoredPaymentMethodsSupported) {
    <form [hidden]="loading" [formGroup]="form" class="padding-bottom-2">
        
                <lib-form-field-paypal-container
                    [formControl]="form.controls.CardNumber"
                    [errorMessages]="cardNumberErrors">

                    <ng-container label
                        i18n="@@CommonAddPaymentSourceCreditCardNumberLabel">
                        Card Number
                    </ng-container>

                    <div id="card-number" class="paypal-card-field"></div>
                </lib-form-field-paypal-container>
                <lib-form-field-paypal-container
                    [formControl]="form.controls.ExpiryDate"
                    [errorMessages]="expiryDateErrors"
                    [layout]="FormFieldLayout.Half">

                    <ng-container label
                        i18n="@@CommonAddPaymentSourceCreditCardExpiryDateLabel">
                        Expiry Date
                    </ng-container>

                    <div id="expiry-date" class="paypal-card-field"></div>
                </lib-form-field-paypal-container>

                <lib-form-field-paypal-container
                    [formControl]="form.controls.CVV"
                    [errorMessages]="cvvErrors"
                    [layout]="FormFieldLayout.Half">
                    <ng-container label
                        i18n="@@CommonAddPaymentSourceCreditCardCVVLabel">
                        CVV
                    </ng-container>
                    <ng-container menu>
                        <lib-icon
                            [icon]="Icon.Common.Help"
                            [size]="IconSize.ThreeExtraSmall"
                            [matTooltip]="cvvTooltip">
                        </lib-icon>
                    </ng-container>

                    <div id="cvv" class="paypal-card-field"></div>
                </lib-form-field-paypal-container>

                <lib-form-field-paypal-container
                    [formControl]="form.controls.CardHolderName"
                    [errorMessages]="cardHolderNameErrors">
                    <ng-container label
                        i18n="@@CommonAddPaymentSourceCreditCardHolderNameLabel">
                        Card Holder Name
                    </ng-container>

                    <div id="cardholder-name" class="paypal-card-field"></div>
                </lib-form-field-paypal-container>

                <lib-input-text
                    [formControl]="form.controls.PostalCode"
                    [kindOverride]="FormContainerKind.PayPalStyleMatch"
                    [errorMessages]="zipCodeError"
                    qaTag="input-paypalcp-zippostalcode"
                    [layout]="FormFieldLayout.Half">
                    <ng-container label
                        i18n="@@CommonAddPaymentSourceCreditCardZipCodeLabel">
                        Zip/Postal Code
                    </ng-container>
                </lib-input-text>

                <lib-input-select
                    [formControl]="form.controls.Country"
                    [kindOverride]="FormContainerKind.PayPalStyleMatch"
                    qaTag="input-paypalcp-country"
                    (change)="GetStates($event!)"
                    [layout]="FormFieldLayout.Half">
                    <ng-container label
                        i18n="@@CommonAddPaymentSourceCountryLabel">
                        Country
                    </ng-container>

                    <lib-input-select-item *ngFor="let country of countries"
                        [value]="country">
                        {{ country.Name }}
                    </lib-input-select-item>
                </lib-input-select>

                <lib-input-select
                    [formControl]="form.controls.State"
                    [kindOverride]="FormContainerKind.PayPalStyleMatch"
                    placeholderText="Select..."
                    i18n-placeholderText="@@CommonSelectPlaceholder"
                    [errorMessages]="stateError"
                    qaTag="input-paypalcp-stateprovince"
                    [layout]="FormFieldLayout.ExclusiveHalf">
                    <ng-container label
                        i18n="@@CommonAddPaymentSourceCreditCardStateProvinceLabel">
                        State/Province
                    </ng-container>

                    <lib-input-select-item *ngFor="let state of states"
                        [value]="state">
                        {{ state.Name }}
                    </lib-input-select-item>
                </lib-input-select>

        @if (Scope.context != PaymentContext.SignupWidget && Scope.mode === PaymentSourceMode.Payment) {
            <lib-checkbox
                [formControl]="form.controls.SavePaymentSource"
                qaTag="save-payment-method-for-future-use-checkbox">
                <ng-container
                    i18n="@@CommonAddPaymentSourceSavePaymentSourceLabel">
                    Save this payment method for future use
                </ng-container>
            </lib-checkbox>
        }

        @if (Scope.context != PaymentContext.SignupWidget && (Scope.mode === PaymentSourceMode.Add || (Scope.mode === PaymentSourceMode.Payment && form.controls.SavePaymentSource.value))) {
                <lib-checkbox
                    [formControl]="form.controls.AutoPay"
                    qaTag="automatically-pay-emailed-invoices-checkbox">
                    <div label
                        i18n="@@CommonAddPaymentSourceAutoPayLabel">
                        Auto Pay
                    </div>
                    <ng-container i18n="@@CommonAddPaymentSourceAutoPayCheckboxDescription">
                        Automatically pay emailed invoices
                    </ng-container>
                </lib-checkbox>
        }

        @if (((Scope.context === PaymentContext.StudentPortal && Scope.mode === PaymentSourceMode.Add) || (Scope.context === PaymentContext.SignupWidget && Scope.mode === PaymentSourceMode.Payment)) && cardSurcharge && cardSurcharge.Type !== SurchargeType.None && paymentSourceType === PaymentSourceType.CreditCard) {
            <div class="sb-form-field-full" [attr.data-sb-qa]="'surcharge-text-creditcard'">
                <lib-label i18n="@@CommonNoteLabel">Note</lib-label>
                @if (cardSurcharge.Type === SurchargeType.Fixed) {
                    <p i18n="@@CommonPaymentFixedSurchargeText">
                        A {{ cardSurcharge.Amount! | formatCurrency }} convenience fee will be applied to all payments.
                    </p>
                }
                @if (cardSurcharge.Type === SurchargeType.Percentage) {
                    <p i18n="@@CommonPaymentPercentageSurchargeText">
                        A {{ cardSurcharge.Amount! | formatPercent: 2: 2 }} convenience fee will be applied to all payments.
                    </p>
                }
            </div>
        }
    </form>
}

<div [hidden]="!loading">
    <div class="h-100 d-flex align-items-center justify-content-center">
        <div class="spinner-border base-100 m-5"></div>
    </div>
</div>